import React, { useMemo, useState } from 'react';
import { Button, Progress, Tag } from 'antd';
import ReactTable from 'react-table';
import TablePagination from '../../../../components/ui/TablePagination';
import { useListSSMagicLinkCsv } from '../../../../query/csv-utilities';
import UserWithAvatar from '../../../../components/ui/UserWithAvatar';
import moment from 'moment';
import SSMagicLinkCSVDownloader from './SSMagicLinkCSVDownloader';

export default function SelfServeMagicLinkCSVTable() {
  const [page, setPage] = useState(1),
    [limit, setLimit] = useState(5);
  const { data, isLoading, refetch } = useListSSMagicLinkCsv({ page, limit });

  const columnDefs = useMemo(() => {
    return [
      {
        Header: 'Uploaded CSV',
        id: 'originalName',
        accessor: row => {
          return <SSMagicLinkCSVDownloader csv={row} type="original" />;
        },
      },
      {
        Header: 'CSV With Magic Links',
        id: 'resultPath',
        accessor: row => {
          if (!row.resultFilepath) return 'N/A';
          return <SSMagicLinkCSVDownloader csv={row} type="result" />;
        },
      },
      {
        Header: 'Uploaded By',
        id: 'owner',
        accessor: row => {
          return <UserWithAvatar user={row.user} />;
        },
      },
      {
        Header: 'Uploaded On',
        id: 'uploadedTime',
        accessor: row => {
          return moment(row.createdAt).format('YYYY-MM-DD HH:mm:ss');
        },
      },
      {
        Header: 'Status',
        id: 'status',
        accessor: row => {
          const percentage = Number(row.rowsProcessed / row.totalRows) * 100;
          let progressStatus = 'active';
          let strokeColor;
          if (Number(percentage) === 100 || row.status === 'completed') {
            progressStatus = 'success';
          } else if (row.status === 'failed') {
            progressStatus = 'normal';
            strokeColor = 'red';
          }
          return (
            <Progress
              percent={percentage}
              showInfo
              status={progressStatus}
              strokeColor={strokeColor}
            />
          );
        },
      },
    ];
  }, []);
  return (
    <div className="w-full" style={{ marginTop: 10 }}>
      <div className="flex items-center space-x-2">
        <h5>Uploaded CSV</h5>
        <Button
          icon="reload"
          loading={isLoading}
          type="primary"
          onClick={() => refetch()}
        >
          Refresh
        </Button>
      </div>

      <ReactTable
        PaginationComponent={TablePagination}
        className={`-highlight`}
        columns={columnDefs}
        data={data?.data || []}
        firstText={<i className="material-icons">first_page</i>}
        lastText={<i className="material-icons">last_page</i>}
        manual
        minRows={0}
        nextText={<i className="material-icons">chevron_right</i>}
        page={page - 1}
        pageSize={limit}
        pageSizeOptions={[5, 10, 15, 20]}
        pages={parseInt(data?.count / limit) + 1}
        previousText={<i className="material-icons">chevron_left</i>}
        rowsSelectorText="Rows per page"
        showPageJump={false}
        showPaginationBottom
        sortable={false}
        onPageChange={nextPage => setPage(nextPage + 1)}
        onPageSizeChange={setLimit}
      />
    </div>
  );
}
